<template>
    <div class="filter-panel d-flex justify-content-between">
        <div class="filter-control" style="width: 70%" @click="onOpenCloseFilter">
            <div class="d-flex justify-content-between" >
                <div>
                    <a href="javascript:void(0)" class="text-secondary"><b>Filtra risultati</b><span> | {{counter}}</span></a>
                </div>
                <div>
                    <button class="btn btn-sm btn-secondary mr-2" :disabled="isDisabledReset" @click="onResetFilter">reset</button>
                </div>
            </div>
        </div>
        <div class="px-2" style="width: 30%">
            <CustomOrderSelect :list="orders" class="lg gray" :value="order" @change="onChangeOrder"/>
        </div>
        <div class="map">
            <div>
                <a href="javascript:void(0)" @click="onOpenMap">mappa</a>
            </div>
        </div>
        <div @mouseleave="openFilter = false">
            <DropdownFilterHotel v-show="openFilter" :list="list" :value="getFilter()"/>
        </div>
        <ModalHotelsMap ref="modalHotelsMap"/>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import DefaultModal from '../../../../../back/components/pages/layout/DefaultModal'
import DropdownFilterHotel from './dropdown/DropdownFilterHotel'
import ModalHotelsMap from './modals/ModalHotelsMap'
import CustomOrderSelect from '../../common/CustomOrderSelect'

export default {
  name: 'FilterHotelPanel',
  components: {CustomOrderSelect, ModalHotelsMap, DropdownFilterHotel, DefaultModal},
  props: {
    counter: Number,
    list: Array
  },
  data: function () {
    return {
      openFilter: false,
      orders: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ],
      openOrder: false
    }
  },
  computed: {
    order () {
      return {name: 'prezzo', dir: this.getOrder()['prezzo']}
    },
    isDisabledReset () {
      return Object.values(this.getFilter()).every(x => x == null)
    }
  },
  methods: {
    ...mapGetters(['getListaHotels', 'getHotelsFilter', 'getHotelsOrder']),
    ...mapActions(['modifyHotelFilter', 'resetHotelFilter', 'modifyHotelOrder']),
    getOrder: function () {
      return this.getHotelsOrder()
    },
    getFilter: function () {
      return this.getHotelsFilter()
    },
    resetFilter: function () {
      this.resetHotelFilter()
    },
    onOpenCloseFilter: function () {
      this.filter = this.getFilter()
      this.openFilter = !this.openFilter
    },
    onOpenOrder: function () {
      this.openOrder = !this.openOrder
      this.openFilter = false
    },
    onOpenMap: function () {
      this.$refs.modalHotelsMap.open()
    },
    onChangeOrder: function (order) {
      this.modifyHotelOrder({prezzo: order.dir})
    },
    onResetFilter: function (event) {
      event.stopPropagation()
      this.resetFilter()
      this.filter = this.getFilter()
      this.openFilter = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/FilterHotelPanel.vue